import React from 'react';
import RespostaList from "./RespostaList";
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router';

const useStyles = makeStyles({
    voltarButton: {
        marginBottom: '20px',
    }
});

export default function RespostaContainer() {
    const classes = useStyles();
    const history = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        history(-1);
    }

    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                className={classes.voltarButton}
                onClick={handleBack}
            >
                <ArrowBackIcon style={{ marginRight: '10px' }} />
                Voltar
            </Button>
            <RespostaList conteudo={location.state.conteudo} />
        </>
    );
}